'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _translate = _interopRequireDefault(require("../translate"));

var _conf = _interopRequireDefault(require("../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _baseForm = _interopRequireDefault(require("./../base-form"));

var _datamasterForms = require("datamaster-forms");

var _formInputs = require("../form-inputs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var collectionMapping = {
  salutation: 'salutations',
  canton: 'cantons',
  mainlanguage: 'languages',
  placedetails: 'placedetails'
};

var BrunchForm = /*#__PURE__*/function (_BaseForm) {
  _inherits(BrunchForm, _BaseForm);

  function BrunchForm(props) {
    var _this;

    _classCallCheck(this, BrunchForm);

    _this = _possibleConstructorReturn(this, (BrunchForm.__proto__ || Object.getPrototypeOf(BrunchForm)).call(this, props));
    _this.state = _lodash.default.extend(_this.state, {
      images: _this.props.images || [],
      documents: _this.props.documents || [],
      uploadModalOpen: {
        images: false,
        documents: false
      },
      paymentmethod: []
    });
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleInputMultiSelectChange = _this.handleInputMultiSelectChange.bind(_assertThisInitialized(_this));
    _this.handleRadioField = _this.handleRadioField.bind(_assertThisInitialized(_this));
    _this.handleMarkerMoved = _this.handleMarkerMoved.bind(_assertThisInitialized(_this));
    _this.handleSponsoringQuestionSwitch = _this.handleSponsoringQuestionSwitch.bind(_assertThisInitialized(_this));
    _this.handleForeignOrganizatorFields = _this.handleForeignOrganizatorFields.bind(_assertThisInitialized(_this));
    _this.handleOrganizatorRadioField = _this.handleOrganizatorRadioField.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   */


  _createClass(BrunchForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var loadRelatedDataCollection = function loadRelatedDataCollection(url, name) {
        // Load categories and subcategories
        fetch(url, {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (objects) {
          _this2.setState(function (prev) {
            prev[name] = objects;
            return prev;
          });
        }).catch(console.error);
      };

      loadRelatedDataCollection(_conf.default.api.paymentMehtodApiUrlTemplate(this.props.i18n.language), 'paymentmethod');
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var t = this.props.t;
      if (this.props.projectNotFound) return /*#__PURE__*/_react.default.createElement("p", null, t('No Projectregistration'));
      return /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.anchorId || '',
        className: "compFarm comp-base-form"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "Farm",
        className: "form-title"
      }, t('Projectdata')), !_lodash.default.isEmpty(this.props.project) && /*#__PURE__*/_react.default.createElement(_datamasterForms.ProjectBrunchForm, _extends({}, this.props, {
        handleInputChange: this.handleInputChange,
        handleInputMultiSelectChange: this.handleInputMultiSelectChange,
        handleRadioField: this.handleRadioField,
        handleForeignOrganizatorFields: this.handleForeignOrganizatorFields,
        handleOrganizatorRadioField: this.handleOrganizatorRadioField,
        handleSponsoringQuestionSwitch: this.handleSponsoringQuestionSwitch,
        onMarkerMoved: this.handleMarkerMoved,
        isSaving: {
          brunch: this.props.isSaving,
          brunchInformation: this.props.isSaving,
          brunchLocation: this.props.isSaving,
          correspondenceInfo: this.props.isSaving,
          organizer: this.props.isSaving,
          orderMaterial: this.props.isSaving,
          brunchTicketPortal: this.props.isSaving
        },
        invalidFields: {
          brunch: this.props.invalidFields.brunch,
          brunchLocation: this.props.invalidFields.brunch,
          correspondenceInfo: this.props.invalidFields.brunch,
          organizer: this.props.invalidFields.brunch,
          orderMaterial: this.props.invalidFields.brunch,
          brunchInformation: this.props.invalidFields.brunch,
          brunchforeignorganisator: this.props.invalidFields.brunchforeignorganisator
        },
        success: {
          brunchInformation: this.props.success,
          brunchLocation: this.props.success,
          correspondenceInfo: this.props.success,
          organizer: this.props.success,
          orderMaterial: this.props.success,
          brunchTicketPortal: this.props.success
        },
        error: {
          brunchInformation: this.props.error,
          brunchLocation: this.props.error,
          correspondenceInfo: this.props.error,
          organizer: this.props.error,
          orderMaterial: this.props.error,
          brunchTicketPortal: this.props.error
        },
        project: this.props.project,
        shared: {
          salutation: this.props.salutations,
          canton: this.props.cantons,
          mainlanguage: this.props.languages,
          placedetails: this.props.placedetails,
          payment_method: this.state.paymentmethod
        },
        locations: this.props.locationtype,
        saveBrunchInformationFields: this.props.saveData,
        saveBrunchLocationFields: this.props.saveData,
        saveCorrespondenceInfoFields: this.props.saveData,
        saveTicketPortalFields: this.props.saveData,
        saveOrderMaterialFields: this.props.saveData,
        saveOrganizerFields: this.props.saveData,
        saveFullyBookedStatus: function saveFullyBookedStatus(e, fieldName, value) {
          _this3.props.updateSingleField(fieldName, value);
        },
        sponsoringQuestion: this.props.sponsoringQuestions,
        sponsoringAnswers: this.props.sponsoringAnswers,
        progress: {
          organizer: null,
          brunchLocation: null,
          correspondenceInfo: null,
          orderMaterial: null,
          brunchInformation: null,
          brunchTicketPortal: null
        },
        InputField: _formInputs.AdapterText,
        InputCheckbox: _formInputs.CheckboxInput,
        InputSelect: _formInputs.AdapterSelect,
        InputTelephone: _formInputs.TelephoneInput,
        InputRadioGroup: _formInputs.InputRadioGroup,
        InputSwitch: _formInputs.InputSwitch,
        InputTextArea: _formInputs.TextareaInput,
        MultiSelectText: _formInputs.AdapterMultiSelect,
        InputIBAN: _formInputs.InputIBAN
      })));
    }
    /**
     *
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(e, fieldName, fieldValue) {
      if (fieldName) {
        return this.props.updateProject(fieldName, fieldValue);
      }

      var target = e.target,
          name = target.name,
          type = target.type;
      var value;
      if (type === 'checkbox') value = target.checked;else if (type === 'select-one') {
        var collection = this.props[collectionMapping[name]];
        value = _lodash.default.find(collection, ['id', target.value]) || _lodash.default.find(collection, ['id', parseInt(target.value)]);
      } else {
        value = target.value;
      }
      this.props.updateProject(name, value);
    }
    /**
     *
     * @param e
     * @param fieldName
     * @param newVal
     */

  }, {
    key: "handleRadioField",
    value: function handleRadioField(e, fieldName, newVal) {
      if (fieldName) {
        var value = _lodash.default.find(this.props[fieldName], ['id', newVal]) || _lodash.default.find(this.props[fieldName], ['id', parseInt(newVal)]);

        this.props.updateProject(fieldName, value);
      }
    }
    /**
     *
     * @param newPosition
     */

  }, {
    key: "handleMarkerMoved",
    value: function handleMarkerMoved(newPosition) {
      this.props.updateProject('latitude', newPosition.latitude.toString());
      this.props.updateProject('longitude', newPosition.longitude.toString());
    }
    /**
     *
     * @param event
     * @param question
     * @param answerIndex
     */

  }, {
    key: "handleSponsoringQuestionSwitch",
    value: function handleSponsoringQuestionSwitch(event, question, answerIndex) {
      var answer;

      if (parseInt(question.question_type) === 0) {
        // Is a radio button
        var field = ['answer1', 'answer2', 'answer3'];
        answer = question[field[answerIndex]];
      } else {
        var target = event.target;
        answer = target.value;
      }

      if (question.question_type === '0') {
        //Radio button
        this.props.updateSponsoringAnswers(question.id, {
          answerIndex: answerIndex,
          answerValue: answer
        });
      }

      if (question.question_type === '1' || question.question_type === '2') {
        // Input/TextBox
        this.props.updateSponsoringAnswers(question.id, {
          answerIndex: null,
          answerValue: answer
        });
      }
    }
    /**
     *
     * @param event
     * @returns {*}
     */

  }, {
    key: "handleOrganizatorRadioField",
    value: function handleOrganizatorRadioField(event) {
      var target = event.target,
          name = target.name;
      var value;

      if (name === 'organisatortype' || name === 'locationtype') {
        value = _lodash.default.find(this.props[name], ['id', target.value]) || _lodash.default.find(this.props[name], ['id', parseInt(target.value)]);
      }

      if (name === 'organisatortype' && parseInt(target.value) === 3) {
        if (this.props.project.farmforeignorganizator.id === -1) {
          return this.props.updateBrunchForeignOrganisator(name, value);
        }
      }

      this.props.updateProject(name, value);
    }
    /**
     *
     * @param fieldName
     * @param selectedItems
     */

  }, {
    key: "handleInputMultiSelectChange",
    value: function handleInputMultiSelectChange(fieldName, selectedItems) {
      var selectedIds = Array.from(selectedItems).map(function (option) {
        return parseInt(option);
      });

      var value = _lodash.default.filter(this.props[fieldName], function (object) {
        return selectedIds.indexOf(parseInt(object.id)) > -1;
      });

      if (fieldName === 'placedetails') {
        value = value.map(function (item) {
          return {
            id: item.id,
            name: item.description || item.name
          };
        });
      }

      this.props.updateProject(fieldName, value);
    }
    /**
     *
     * @param event
     * @param fieldName
     * @param newVal
     * @returns {*|void}
     */

  }, {
    key: "handleForeignOrganizatorFields",
    value: function handleForeignOrganizatorFields(event, fieldName, newVal) {
      if (fieldName) {
        this.props.updateProject(fieldName, newVal);
      }

      var target = event.target,
          name = target.name,
          type = target.type;
      var value;
      if (type === 'checkbox') value = target.checked;else if (type === 'select-one') {
        if (name === 'languageofcorrespondence') {
          value = _lodash.default.find(this.props.languages, ['id', target.value]) || _lodash.default.find(this.props.languages, ['id', parseInt(target.value)]);
        } else {
          value = _lodash.default.find(this.props[collectionMapping[name]], ['id', target.value]) || _lodash.default.find(this.props[collectionMapping[name]], ['id', parseInt(target.value)]);
        }
      } else {
        value = target.value;
      }
      this.props.updateProject('foreignorganizator.' + name, value);
    }
    /**
     *
     * @param e
     * @param imageId
     * @param brunchId
     * @param type
     */

  }, {
    key: "onDeleteImage",
    value: function onDeleteImage(e, imageId, brunchId, type) {
      var _this4 = this;

      e.preventDefault();

      var uri = _conf.default.api.brunchApiRemoveImage(this.props.i18n.language, this.props.id, this.props.project.id, imageId);

      if (type === 'documents') {
        uri = _conf.default.api.brunchApiRemoveDocument(this.props.i18n.language, this.props.id, this.props.project.id, imageId);
      }

      fetch(uri, {
        credentials: 'include',
        method: 'DELETE'
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this4.setState(function (prev) {
          prev[type] = prev[type].filter(function (image) {
            return image.id !== result.fileId;
          });
          return prev;
        });
      });
    }
  }]);

  return BrunchForm;
}(_baseForm.default);

BrunchForm.defaultProps = {
  isSaving: false,
  error: ''
};
BrunchForm.propTypes = {
  t: _propTypes.default.func.isRequired,
  history: _propTypes.default.any.isRequired,
  sponsoringAnswers: _propTypes.default.object.isRequired,
  questionIdFieldNameMap: _propTypes.default.object.isRequired,
  salutations: _propTypes.default.array.isRequired,
  cantons: _propTypes.default.array.isRequired,
  placedetails: _propTypes.default.array.isRequired,
  languages: _propTypes.default.array.isRequired,
  sponsoringQuestions: _propTypes.default.array.isRequired,
  organisatorTypes: _propTypes.default.array.isRequired,
  locationtype: _propTypes.default.array.isRequired,
  organisatortype: _propTypes.default.array.isRequired,
  locationTypes: _propTypes.default.array.isRequired,
  updateProject: _propTypes.default.func.isRequired,
  updateSponsoringAnswers: _propTypes.default.func.isRequired,
  updateBrunchForeignOrganisator: _propTypes.default.func.isRequired,
  updateSingleField: _propTypes.default.func.isRequired,
  saveData: _propTypes.default.func.isRequired,
  isSaving: _propTypes.default.bool,
  error: _propTypes.default.string,
  success: _propTypes.default.bool,
  invalidFields: _propTypes.default.shape({
    brunch: _propTypes.default.shape({
      fields: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
      details: _propTypes.default.object
    }),
    brunchforeignorganisator: _propTypes.default.shape({
      fields: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
      details: _propTypes.default.object
    })
  })
};

var _default = (0, _translate.default)(BrunchForm);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/brunch/index.js
// module id = 583
// module chunks = 0